export const getThreadsByType = (threadsArray, isBulletin) => {
  if (isBulletin) {
    // Return ONLY threads with type === "bulletin"
    return threadsArray.filter((thread) => thread.type === 'bulletin');
  }

  // Else: return threads with type === "project-bank" OR no type at all,
  return threadsArray.filter(
    (thread) => !thread?.type || thread.type === 'project-bank'
  );
};
